export default "__VITE_ASSET__c71NpHkm__"